(() => {
  const initialize = (root) => {
    if (root.dataset.cmGeReady === 'true') return;
    root.dataset.cmGeReady = 'true';
    const preferences = root.querySelector('[data-cm-ge-preferences]');
    const workshop = root.querySelector('[data-cm-ge-workshop-select]');
    const date = root.querySelector('[data-cm-ge-date]');
    const flexible = root.querySelector('[data-cm-ge-flexible]');
    const status = root.querySelector('[data-cm-ge-selection]');
    const app = root.querySelector('[data-cm-ge-app]');
    const fallback = root.querySelector('[data-cm-ge-fallback]');
    const enquiry = root.querySelector('.cm-ge__enquiry');
    let form = null;
    let notes = null;
    let eventKey = '';
    let eventName = '';
    let managedText = '';
    let choosingEvent = false;
    const eventValues = { corporate: 'Team Bonding Event', hens: 'Bride-To-Be', birthday: 'Birthday Party', christmas: 'Others', private: 'Others', kids: 'Others' };

    const notifyField = (field) => {
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const sync = () => {
      if (!form || !notes) return;
      date.disabled = flexible.checked;
      const lines = [];
      const checkedEvents = [...form.querySelectorAll('input[name="checkbox-2[]"]:checked')].map((field) => field.value);
      const selectedEvent = eventKey && checkedEvents.length === 1 && checkedEvents[0] === eventValues[eventKey] ? eventName : checkedEvents.join(', ');
      if (selectedEvent) lines.push(`${root.dataset.eventLabel}: ${selectedEvent}`);
      if (workshop.value) lines.push(`${root.dataset.workshopLabel}: ${workshop.value}`);
      if (flexible.checked) lines.push(`${root.dataset.dateLabel}: ${root.dataset.flexibleValue}`);
      else if (date.value) lines.push(`${root.dataset.dateLabel}: ${date.value}`);
      const nextManaged = lines.length ? `${root.dataset.preferencesHeading}\n${lines.join('\n')}\n\n` : '';
      const freeText = managedText ? notes.value.replace(managedText, '') : notes.value;
      const nextValue = nextManaged + freeText;
      if (notes.value !== nextValue) {
        notes.value = nextValue;
        notifyField(notes);
      }
      managedText = nextManaged;
      const nextStatus = lines.join(' · ');
      if (status.textContent !== nextStatus) status.textContent = nextStatus;
      status.hidden = !lines.length;
    };

    const chooseEvent = () => {
      if (!form || !eventKey) return;
      const value = eventValues[eventKey];
      if (!value) return;
      choosingEvent = true;
      form.querySelectorAll('input[name="checkbox-2[]"]').forEach((field) => {
        const checked = field.value === value;
        if (field.checked !== checked) {
          field.checked = checked;
          notifyField(field);
        }
      });
      choosingEvent = false;
    };

    const connectForm = () => {
      const nextForm = app.querySelector('form[data-id="116287"]');
      const nextNotes = nextForm?.querySelector('textarea[name="textarea"]');
      if (!nextForm || !nextNotes || (form === nextForm && notes === nextNotes)) return;
      form = nextForm;
      notes = nextNotes;
      managedText = '';
      preferences.hidden = false;
      fallback.hidden = true;
      form.addEventListener('change', (event) => {
        if (choosingEvent || !event.target.matches('input[name="checkbox-2[]"]')) return;
        eventKey = '';
        eventName = '';
        sync();
      });
      chooseEvent();
      sync();
    };

    const scrollToEnquiry = () => {
      enquiry.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      const title = enquiry.querySelector('h2');
      title.setAttribute('tabindex', '-1');
      title.focus({ preventScroll: true });
    };

    root.addEventListener('click', (event) => {
      const eventLink = event.target.closest('[data-cm-ge-event]');
      const workshopLink = event.target.closest('[data-cm-ge-workshop]');
      if ((!eventLink && !workshopLink) || !root.contains(event.target)) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (eventLink) {
        eventKey = eventLink.dataset.cmGeEvent;
        eventName = eventLink.dataset.cmGeValue;
        chooseEvent();
      }
      if (workshopLink) workshop.value = workshopLink.dataset.cmGeWorkshop;
      sync();
      scrollToEnquiry();
    });

    [workshop, date, flexible].forEach((field) => field.addEventListener('change', sync));
    new MutationObserver(connectForm).observe(app, { childList: true, subtree: true });
    connectForm();
  };
  const scan = (scope) => {
    if (scope.matches?.('[data-cm-ge]')) initialize(scope);
    scope.querySelectorAll('[data-cm-ge]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
